import { render, staticRenderFns } from "./SelectBase.vue?vue&type=template&id=65dd4539&scoped=true&"
import script from "./SelectBase.vue?vue&type=script&lang=js&"
export * from "./SelectBase.vue?vue&type=script&lang=js&"
import style0 from "./SelectBase.vue?vue&type=style&index=0&id=65dd4539&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd4539",
  null
  
)

export default component.exports